// Hook odpowiedzialny za import produktów z pliku CSV

import { axios } from 'api';
import { useMutation, UseMutationOptions } from 'react-query';
import { ICommandResponseError as IError, ICommandResponseSuccess } from 'api/types';

export interface IRequest {
  file: string;
}

type IResponse = ICommandResponseSuccess;

const postPanelProductsImport = (data: IRequest): Promise<IResponse> =>
  axios.post('/panel/products/import', data);

export const usePostPanelProductsImport = (
  options?: UseMutationOptions<IResponse, IError, IRequest>
) => useMutation((data: IRequest) => postPanelProductsImport(data), options);
